export default "__VITE_ASSET__BFL6uIDb__"